// src/features/dashboard/services/Employee/employeeProductivity.service.ts

import api from '../../../../api/apiService';
import { ENDPOINTS } from '../../../../api/endpoints';

import {
  EmployeeProductivityRequest,
  EmployeeProductivityKpiResponse,
  HourlyProductivityResponse,
  TimeClassificationResponse,
  ProductivityTrendResponse,
  MeVsTeamResponse,
  MonthlyProductivityTrendResponse,
  ApplicationDetailResponse,
} from '../../types/Employee/employeeProductivity.types';

/* ============================================================================
 * KPI
 * ========================================================================== */

export const getEmployeeProductivityKPIs = async (
  request: EmployeeProductivityRequest,
): Promise<EmployeeProductivityKpiResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_PRODUCTIVITY_KPI,
    {
      employeeCode: request.employeeCode,
      date: request.date,
    },
  );

  return data;
};

/* ============================================================================
 * HOURLY PRODUCTIVITY
 * ========================================================================== */

export const getHourlyProductivityChart = async (
  request: EmployeeProductivityRequest,
): Promise<HourlyProductivityResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_PRODUCTIVITY_HOURLY_TREND,
    {
      employeeCode: request.employeeCode,
      date: request.date,
    },
  );

  return data;
};

/* ============================================================================
 * TIME CLASSIFICATION
 * ========================================================================== */

export const getTimeClassification = async (
  request: EmployeeProductivityRequest,
): Promise<TimeClassificationResponse[]> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_PRODUCTIVITY_TIME_CLASSIFICATION,
    {
      employeeCode: request.employeeCode,
      date: request.date,
    },
  );

  return Array.isArray(data)
    ? data
    : [];
};

/* ============================================================================
 * WTD PRODUCTIVITY TREND
 * ========================================================================== */

export const getProductivityWTDTrend = async (
  request: EmployeeProductivityRequest,
): Promise<ProductivityTrendResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_PRODUCTIVITY_WTD_TREND,
    {
      employeeCode: request.employeeCode,
      date: request.date,
    },
  );

  return data;
};

/* ============================================================================
 * ME VS TEAM
 * ========================================================================== */

export const getMeVsTeamProductivity = async (
  request: EmployeeProductivityRequest,
): Promise<MeVsTeamResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_PRODUCTIVITY_ME_VS_TEAM,
    {
      employeeCode: request.employeeCode,
      currentDate: request.date,
    },
  );

  return data;
};

/* ============================================================================
 * MONTHLY PRODUCTIVITY
 * ========================================================================== */

export const getMonthlyProductivityTrend = async (
  request: EmployeeProductivityRequest,
): Promise<MonthlyProductivityTrendResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_PRODUCTIVITY_MONTHLY_TREND,
    {
      employeeCode: request.employeeCode,
      date: request.date,
    },
  );

  return data;
};

/* ============================================================================
 * APPLICATION DETAILS
 *
 * API RESPONSE:
 *
 * {
 *   details: [],
 *   summary: {
 *     totalDuration: "08:16:48",
 *     productivePercentage: 72.5
 *   }
 * }
 * ========================================================================== */

export const getApplicationDetails = async (
  request: EmployeeProductivityRequest,
): Promise<ApplicationDetailResponse> => {
  const { data } = await api.post(
    ENDPOINTS.EMPLOYEE_PRODUCTIVITY_APPLICATION_DETAIL,
    {
      employeeCode: request.employeeCode,
      date: request.date,
    },
  );

  return data;
};